import Vue from 'vue';
import App from './App';
import router from './router';
import VueCookies from 'vue-cookies';
import * as VueGoogleMaps from 'vue2-google-maps'
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import IconBase from '@/components/IconBase.vue'
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faHome } from "@fortawesome/free-solid-svg-icons";
import {
  faPlus, faFilter, faSearchLocation, faDownload, faUpload, faCalendarCheck, faLock, faExclamationCircle, faFlag, faPlusSquare, faSquareCheck,
  faSpinner, faTag, faInbox, faList, faMapPin, faCheck, faPlusCircle, faTrash, faUsers, faBoxOpen, faBell, faChartBar, faCog, faChevronDown, faChevronUp,
  faUserSecret, faTasks, faHeartbeat, faFile, faFileSignature, faClipboardCheck, faCircleInfo, faCircle, faPlay, faPhone, faEnvelope, faExclamationTriangle, faSearch,
  faFlagPennant, faHomeAlt, faFileChartLine, faEye, faFilePdf, faDatabase, faCircleX, faCaretDown, faCaretUp, faHouse, faTimes, faCommentsAlt, faInfoSquare,
  faStepBackward, faStop, faStepForward, faArrowAltCircleUp, faUsdCircle, faPlayCircle, faCloudExclamation, faFileChartColumn,
  faHouseChimney, faSensorTriangleExclamation, faCircleXmark, faX, faSensorAlert, faCircleCheck
} from '@fortawesome/pro-solid-svg-icons';
import {
  faBug,faTrashAlt
} from '@fortawesome/pro-light-svg-icons';
import { faSync, faStickyNote, faSave, faFileExcel } from '@fortawesome/pro-duotone-svg-icons'
import { faCloudArrowDown, faCloudArrowUp, faEllipsisV } from '@fortawesome/pro-regular-svg-icons'
import { Auth0Plugin } from "./auth";
import { domain, clientId } from "../auth_config.json";
import VueMatomo from 'vue-matomo'
import { errorHandler } from './components/errorHandler';
import ReusableComponents from '@ccrpd/ccr-reusuable-components';
import vuetify from './plugins/vuetify';
import AxiosPlugin from './plugins/axios'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Sentry.init({
  Vue,
  dsn: "https://c7cd5110e2ce4257bcfbcbe3dc59a6c2@o283908.ingest.sentry.io/5710003",
  integrations: [new Integrations.BrowserTracing()],
  logErrors: true,
  environment: process.env.NODE_ENV,
  //process.env.NODE_ENV
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Vue.component('icon-base', IconBase);

library.add(faCloudArrowDown, faCloudExclamation, faCloudArrowUp, faPlus, faFilter, faSearchLocation, faDownload, faUpload, faCalendarCheck, faLock, faExclamationCircle, faFlag, faPlusSquare, faSquareCheck,
  faSpinner, faTag, faInbox, faList, faMapPin, faCheck, faPlusCircle, faTrash, faUsers, faBoxOpen, faBell, faChartBar, faCog, faUserSecret,
  faHeartbeat, faTasks, faFile, faFileSignature, faClipboardCheck, faCircleInfo, faCircle, faPlay, faPhone, faEnvelope, faExclamationTriangle,
  faSync, faFileExcel, faStickyNote, faSave, faChevronDown, faChevronUp, faCircleXmark, faFlagPennant, faHomeAlt, faFileChartLine, faCircleCheck, faEye, faFilePdf, faEllipsisV,
  faDatabase, faCaretDown, faCaretUp, faHome, faX, faCommentsAlt, faInfoSquare, faSearch, faStepBackward, faStop, faStepForward, faArrowAltCircleUp,
  faUsdCircle, faPlayCircle, faSensorAlert, faFileChartColumn, faHouse, faHouseChimney, faBug,faTrashAlt);
Vue.component('font-awesome-icon', FontAwesomeIcon);
dom.watch()

let GOOGLE_API_KEY = process.env.VUE_APP_GOOGLE_API_KEY

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueCookies)
Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_API_KEY,
    libraries: "places" //necessary for places input
  },
  installComponents: true
});

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

let userCookie = Vue.$cookies.get('savedUser');
Vue.use(AxiosPlugin);

Vue.use(VueMatomo, {
  host: 'https://matomo.ccr.net/',
  siteId: 10,
  trackerFileName: 'matomo',
  trackerUrl: 'https://matomo.ccr.net/matomo.php',
  router: router,
  enableLinkTracking: true,
  trackInitialView: false, // Changed from true to false
  debug: true
  // host: 'https://matomo.ccr.net/',
  // siteId: 5,
  // trackerFileName: 'matomo',
  // trackerUrl: 'https://matomo.ccr.net/matomo.php',
  // router: router,
  // enableLinkTracking: true,
  // trackInitialView: true,
  // userId: userCookie ? userCookie.UserDetails.Contact_RecID : undefined,
  // debug: true,
  // preInitActions: [
  //   ["setCustomVariable", 1, "Company", userCookie ? userCookie.UserDetails.Contact_Company_RecID : undefined, "visit"],
  // ]
})
Vue.use(ReusableComponents);
Vue.mixin({
  methods: {
    errorHandler: errorHandler,
  }
})

new Vue({
  el: '#app',
  router,
  icons,
  template: '<App/>',
  vuetify,

  components: {
    App
  }
})
